import "./App.css";
import Navbar from "./components/Navbar";
import NewsBox from "./components/NewsBox";
import { BrowserRouter, Routes, Route } from "react-router-dom";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route
            exact
            path="/arts"
            element={<NewsBox key="arts" category="arts" />}
          ></Route>
          <Route
            exact
            path="/"
            element={<NewsBox key="home" category="home" />}
          ></Route>
          <Route
            exact
            path="/science"
            element={<NewsBox key="science" category="science" />}
          ></Route>
          <Route
            exact
            path="/world"
            element={<NewsBox key="world" category="world" />}
          ></Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
